import { useCallback, useEffect } from 'react'

import { useShallow } from 'zustand/react/shallow'
import { useCADPageStore } from '@/state/cad'
import { useResetGLTF } from '@/services/queries/cads'

export const useCADPageListeners = () => {
  const isEditModeActive = useCADPageStore(
    useShallow((state) => state.isEditModeActive),
  )
  const isRetakeModeActive = useCADPageStore(
    useShallow((state) => state.isRetakeModeActive),
  )
  const activeOperationStep = useCADPageStore((state) => state.operationStep)
  const { reset: resetGLTF } = useResetGLTF()

  const resetEditMode = useCADPageStore(
    useShallow((state) => state.resetEditMode),
  )
  const resetRetakeMode = useCADPageStore(
    useShallow((state) => state.resetRetakeMode),
  )
  const onResetEditMode = useCallback(() => {
    resetRetakeMode()
    resetEditMode()
    resetGLTF()
  }, [resetEditMode, resetGLTF, resetRetakeMode])

  const onExitEditMode = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') onResetEditMode()
    },
    [onResetEditMode],
  )

  const onUnselectStep = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        resetGLTF()
      }
    },
    [resetGLTF],
  )

  useEffect(() => {
    if (isEditModeActive || isRetakeModeActive) {
      document.addEventListener('keydown', onExitEditMode)
    } else {
      document.removeEventListener('keydown', onExitEditMode)
    }

    return () => {
      document.removeEventListener('keydown', onExitEditMode)
    }
  }, [isEditModeActive, isRetakeModeActive, onExitEditMode])

  useEffect(() => {
    if (activeOperationStep && !isEditModeActive) {
      document.addEventListener('keydown', onUnselectStep)
    } else {
      document.removeEventListener('keydown', onUnselectStep)
    }

    return () => {
      document.removeEventListener('keydown', onUnselectStep)
    }
  }, [activeOperationStep, isEditModeActive, onUnselectStep])
}
